import { useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { sessionQueryOptions, useLogout } from '@/features/auth/queries';
import { TotpCard } from '@/features/auth/TotpCard';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export function AccountPage() {
  const session = useQuery(sessionQueryOptions);
  const logout = useLogout();
  const navigate = useNavigate();

  return (
    <div className="flex max-w-md flex-col gap-6">
      <h1 className="text-2xl font-semibold">Compte</h1>

      <Card>
        <CardHeader>
          <CardTitle>{session.data?.email}</CardTitle>
        </CardHeader>
        <CardContent>
          <Button
            variant="outline"
            onClick={() => {
              logout.mutate(undefined, { onSuccess: () => void navigate({ to: '/login' }) });
            }}
          >
            Se déconnecter
          </Button>
        </CardContent>
      </Card>

      <TotpCard enabled={session.data?.totpEnabled ?? false} />
    </div>
  );
}
